import React, {ReactNode} from "react";
import {
  TaskCheckboxChildren,
  TaskCheckboxFadedSmall,
  TaskCheckboxContextProvider,
} from "../../../../task-checkbox-field";
import {Checklist} from "../../checklist";
import {getChecklistFormValues} from "../../../helper";
import {PccDocumentUploadTaskCheckbox} from "../../pcc-document-upload-task-checkbox";
import {AdmissionChecklistProps} from "./utils/types";
import {DisabledNotApplicableStatusOption} from "./DisableNotApplicableStatusOption";
import {
  ChecklistItemDateHoverSlot,
  ChecklistItemTextColumn,
  Label,
  SmallFieldErrorText,
} from "./style";

export const AdmissionChecklistRenderer = ({
  checklist,
  validationErrors,
  isPccDocumentUploadEnabled,
  onChange,
  onUpload,
}: AdmissionChecklistProps) => {
  const initialValues = getChecklistFormValues(checklist);

  return (
    <TaskCheckboxContextProvider>
      <Checklist
        onChange={onChange}
        checklist={checklist}
        initialValues={initialValues}
        validationErrors={validationErrors}
      >
        {({checklistItem, validationError, disabled}) => (
          <TaskCheckboxFadedSmall
            key={checklistItem.id}
            name={checklistItem.id}
            disabled={disabled}
            Label={Label}
            label={checklistItem.description}
            renderTrailingWithCaret={({FormattedDate}) => (
              <ChecklistItemDateHoverSlot
                data-checklist-item-date-hover=""
                size="small"
              >
                <FormattedDate />
              </ChecklistItemDateHoverSlot>
            )}
            onComplete={
              isPccDocumentUploadEnabled && checklistItem.documentUploadRequired
                ? ({setCheckboxClosed}) => {
                    setCheckboxClosed();
                    onUpload(checklistItem);
                  }
                : undefined
            }
            renderNotApplicableStatusOption={
              isPccDocumentUploadEnabled && checklistItem.documentUploadRequired
                ? DisabledNotApplicableStatusOption
                : undefined
            }
            children={
              isPccDocumentUploadEnabled
                ? (props: TaskCheckboxChildren) => (
                    <PccDocumentUploadTaskCheckbox
                      {...props}
                      checklistItem={checklistItem}
                      onUpload={onUpload}
                    />
                  )
                : ({Checkbox, Label: LabelSlot}) => (
                    <>
                      <Checkbox />
                      <ChecklistItemTextColumn>
                        <LabelSlot />
                      </ChecklistItemTextColumn>
                    </>
                  )
            }
            CheckboxWrapper={
              (({children}: {children: ReactNode}) => (
                <>
                  <div>{children}</div>
                  {validationError && (
                    <SmallFieldErrorText>{validationError}</SmallFieldErrorText>
                  )}
                </>
              )) as any
            }
          />
        )}
      </Checklist>
    </TaskCheckboxContextProvider>
  );
};
